import { Injectable, Inject } from '@angular/core';
import { ISettingsModel } from '@lightstone/config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IDisplayResultValue } from '../../models/display-result.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LsJupiterProductManagementService {
  headers: { 'Content-Type': string; 'x-Authenticated-TenantId'?: string; 'Ocp-Apim-Subscription-Key'?: string; };

  constructor(@Inject('SettingsModel') private config: ISettingsModel, private httpCllient: HttpClient) {

    this.headers = {
      'Content-Type': 'application/json'
    };
    if (this.config.apiKey){
      this.headers['Ocp-Apim-Subscription-Key'] = this.config.apiKey;
    }
    if (this.config.tenantId) {
      this.headers['x-Authenticated-TenantId'] = this.config.tenantId;
    }
  }

  public GetAllUserProducts(): Observable<IDisplayResultValue[]> {
    return this.httpCllient.get<IDisplayResultValue[]>(
      `${this.config.baseUrl}lightstone-productmanagement-webapi/${this.config.apiVersion}/Product/Get`,
      { headers: this.headers })

      .pipe(map(result => {
        return result;
      }));
  }
}
